import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { SquadBustersGameParams } from "../../validation/game-params";

import { NewsView } from "./view";

export const NewsController = () => {
    const { gameParams } = useGameParamsContext<SquadBustersGameParams>();
    const { pathname: pagePath } = useLocation();
    const { trackPageView } = useSnowplowContext();

    useEffect(() => {
        trackPageView("News", pagePath);

        window.history.pushState({ home: true }, undefined);
    }, []);

    const props = {
        hideSocialLinks: !!gameParams.youngPlayer,
    };

    return <NewsView {...props} />;
};
